import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectPostClosing } from 'store/loanApplications/selectors';
import { selectPostClosingOptionsByListType } from 'store/system/selectors';

import { getPostClosingSelectOptions } from '../EditDrawer/EditDrawer.utils';

export const usePostClosingSelectOptions = () => {
  const postClosing = useSelector(selectPostClosing);
  const optionsByListType = useSelector(selectPostClosingOptionsByListType);

  return useMemo(
    () => getPostClosingSelectOptions({ optionsByListType, postClosing }),
    [optionsByListType, postClosing],
  );
};
